export const LOAN_CONTAINER_TAG_NAME = 'loan-container';
